import { computed, ref, getCurrentInstance} from "@vue/composition-api";
import store from "@/store";
import axios from "@/libs/axios";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import { encryptData } from "@/utils/encryptUserDataUtils";
import { debounce } from "lodash";
import { useTranslates } from "@/utils/useTranslates";

export function useNetworkInfo(dvr) {
  const toast = useToast();
  const networkInfo = ref (null);
  const isNetworkInfoLoading = ref(false)
  const showNoDataMessage = ref(false)

  async function getNetworkInfo() {
    try {
      const params = {
        idDvr: dvr.id,
      }
      isNetworkInfoLoading.value = true
      const {data} = await axios.get('/v1/hanwha/dvr/admin/get_network_info', {params})
      networkInfo.value = data.data
      if (Array.isArray(data.data) && data.data.length === 0) showNoDataMessage.value = true
      isNetworkInfoLoading.value = false
    } catch(error) {
      isNetworkInfoLoading.value = false
      showNoDataMessage.value = true
      toast({
        component: ToastificationContent,
        props: {
          title: error?.response?.data?.message ?? 'Error getting network information',
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    }
  }

  return {
    isNetworkInfoLoading,
    showNoDataMessage,
    networkInfo,
    getNetworkInfo
  }
}